<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Partner', to: { path: '/partnership-member' } },
                { text: 'Detail Partner' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Detail Partner</h3>

        <v-card flat>
            <v-card-title>
                Detail Profile <v-spacer></v-spacer>

                <!-- <v-btn
          depressed
          rouded
          small
          class="pa-2"
          height="33px"
          color="#FF4D4D"
          style="min-width: 0 !important"
        >
          <v-icon color="white" style="font-size: 20px">
            mdi-delete-outline
          </v-icon>
        </v-btn>

        <v-btn
          depressed
          rouded
          small
          class="pa-3 ml-2"
          height="33px"
          color="primary"
          style="min-width: 0 !important; color: #fff"
          @click="detailFormPartnership()"
        >
          <v-icon style="font-size: 20px"> mdi-pencil </v-icon>
          Ubah Partner
        </v-btn> -->
            </v-card-title>
            <v-divider />

            <v-card-text class="px-5 pt-5" v-if="isLoading">
                <v-skeleton-loader
                    type="card"
                    height="320"
                    width="100%"
                ></v-skeleton-loader>
            </v-card-text>

            <v-card-text v-if="!isLoading">
                <div class="mt-5">
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr style="background-color: #f7f6f3">
                                    <td width="20%">Tanggal Dibuat</td>
                                    <td>
                                        {{ data.tanggal_buat }}6 Desember 2023
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
                <div class="mt-8">
                    <div>
                        <h4 class="font-weight-bold mb-4 ml-4">
                            Detail Profil Partner
                        </h4>
                    </div>
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td width="20%">Nama Partner</td>
                                    <td>{{ data.nama }}</td>
                                </tr>
                                <tr>
                                    <td>Provinsi</td>
                                    <td>
                                        {{
                                            data.partner_provinsi.nama_provinsi
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Kota/Kabupaten</td>
                                    <td>
                                        {{
                                            data.partner_kabupaten_kota
                                                .nama_kabupaten_kota
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Kecamatan</td>
                                    <td>
                                        {{
                                            data.partner_kecamatan
                                                .nama_kecamatan
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Kelurahan</td>
                                    <td>
                                        {{
                                            data.partner_kelurahan
                                                .nama_kelurahan_desa
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Alamat Lengkap Sekolah</td>
                                    <td>
                                        {{ data.alamat }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Nomor Telepon</td>
                                    <td>
                                        {{ data.no_telp }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Kepala Sekolah</td>
                                    <td>
                                        {{ data.nama_kepsek || "-" }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Surat Kesepakatan</td>
                                    <td class="py-2">
                                        <v-btn
                                            depressed
                                            dark
                                            small
                                            color="#E0F2F1"
                                            class="mr-2 my-1 py-4"
                                            style="color: #26a69a"
                                            v-for="(doc, index) of document"
                                            :key="index"
                                            @click="openDocument(doc)"
                                        >
                                            <v-icon
                                                style="
                                                    font-size: 20px;
                                                    margin-right: 5px;
                                                "
                                            >
                                                mdi-file-outline
                                            </v-icon>

                                            {{ doc.data_name }}
                                        </v-btn>

                                        <span
                                            v-if="!document.length"
                                            style="color: gray"
                                        >
                                            Belum ada surat kesepakatan
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Status</td>
                                    <td class="py-3">
                                        <div v-if="data.status === 'WAITING'">
                                            <v-btn
                                                depressed
                                                color="primary"
                                                :disabled="
                                                    !document.length ||
                                                    !list_program.length
                                                "
                                                v-on:click="
                                                    confirmApprove('APPROVE')
                                                "
                                            >
                                                <v-icon
                                                    style="font-size: 20px"
                                                    class="mr-1"
                                                >
                                                    mdi-check
                                                </v-icon>
                                                Setujui
                                            </v-btn>

                                            <v-btn
                                                depressed
                                                dark
                                                color="#FF4D4D"
                                                class="ml-2"
                                                v-on:click="
                                                    confirmApprove('REJECT')
                                                "
                                            >
                                                <v-icon
                                                    style="font-size: 20px"
                                                    class="mr-1"
                                                >
                                                    mdi-close
                                                </v-icon>
                                                Tolak
                                            </v-btn>
                                        </div>

                                        <div v-else>
                                            <v-btn
                                                v-if="data.status === 'WAITING'"
                                                small
                                                depressed
                                                rounded
                                                color="#E8F5FA"
                                                style="color: #2690cb"
                                            >
                                                Belum Disetujui
                                            </v-btn>

                                            <v-btn
                                                v-if="data.status === null"
                                                small
                                                depressed
                                                rounded
                                                color="#FFF3E0"
                                                style="color: orange"
                                            >
                                                Draft
                                            </v-btn>

                                            <v-btn
                                                v-if="data.status === 'REJECT'"
                                                small
                                                depressed
                                                rounded
                                                color="#FFE5E5"
                                                style="color: #ec675e"
                                            >
                                                Ditolak
                                            </v-btn>

                                            <v-btn
                                                v-if="data.status === 'APPROVE'"
                                                small
                                                depressed
                                                rounded
                                                color="#EEFFE0"
                                                style="color: #40bf75"
                                            >
                                                Disetujui
                                            </v-btn>

                                            <v-btn
                                                v-if="
                                                    data.status === 'REGISTER'
                                                "
                                                small
                                                depressed
                                                rounded
                                                color="#E0F2F1"
                                                style="color: #26a69a"
                                            >
                                                Baru
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>

                <div class="mt-10 mb-5">
                    <div>
                        <v-row>
                            <v-col cols="12" md="9">
                                <h4 class="font-weight-bold mb-4 ml-4">
                                    Detail Program
                                </h4>
                            </v-col>
                            <v-col class="text-right pr-8">
                                <v-btn
                                    depressed
                                    rouded
                                    small
                                    class="pa-3 ml-2"
                                    height="33px"
                                    color="#E1F5FE"
                                    style="color: #039be5"
                                    dark
                                    @click="dialog_program = true"
                                >
                                    <v-icon
                                        style="font-size: 20px"
                                        class="mr-1"
                                    >
                                        mdi-plus
                                    </v-icon>
                                    Tambah Program
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <td width="30%"><b>Nama Program</b></td>
                                    <td width="30%">
                                        <b>Pemilik Program</b>
                                    </td>
                                    <td>
                                        <b>Deskripsi</b>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(row, index) in list_program">
                                    <tr>
                                        <td>{{ row.name }}</td>
                                        <td>
                                            {{ row.data_owner.nama || "-" }}
                                        </td>
                                        <td>
                                            {{ row.description }}
                                        </td>
                                    </tr>
                                </template>

                                <template v-if="!list_program.length">
                                    <tr style="background-color: #f7f6f3">
                                        <td colspan="3" align="center">
                                            Belum ada program
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>

                <div class="mt-10 mb-5" v-if="data.data_pic">
                    <div>
                        <h4 class="font-weight-bold mb-4 ml-4">
                            Detail Profil Penanggung Jawab
                        </h4>
                    </div>
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <template v-for="(row, index) in data.data_pic">
                                    <tr>
                                        <td width="20%">
                                            Nama PIC {{ index + 1 }}
                                        </td>
                                        <td>
                                            {{ row.nama }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Nomor Telepon</td>
                                        <td>
                                            {{ row.noTelp }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Email</td>
                                        <td>
                                            {{ row.email }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Jabatan</td>
                                        <td>
                                            {{ row.jabatan }}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </template>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog
            v-if="confirm_approve"
            v-model="confirm_approve"
            max-width="370"
        >
            <template>
                <v-card>
                    <v-card-title style="word-break: break-word !important">
                        {{ approval_title }}
                    </v-card-title>

                    <v-card-actions class="pb-5">
                        <v-spacer></v-spacer>

                        <v-btn
                            color="blew"
                            dark
                            depressed
                            @click="sendProcessPartner()"
                            :loading="loading_approve"
                        >
                            {{
                                approval_status === "APPROVE"
                                    ? "Setuju"
                                    : "Tolak"
                            }}
                        </v-btn>

                        <v-btn
                            color="darkFade"
                            text
                            @click="confirm_approve = false"
                        >
                            Batal
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <v-dialog
            v-if="dialog_program"
            v-model="dialog_program"
            max-width="1000"
            scrollable
        >
            <template>
                <v-card>
                    <v-toolbar dark color="#0277BD">
                        <v-toolbar-title>
                            Daftar Partnership Program
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            class="mr-1"
                            icon
                            dark
                            @click="dialog_program = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <partnership-program
                            @selectedRow="selectedRowProgram($event)"
                        ></partnership-program>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>

        <!-- <app-spinner v-if="isLoading"></app-spinner> -->
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import PartnershipProgramDialog from "@/modules/partnership/components/PartnershipProgramDialog";
import axios from "axios";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
        "partnership-program": PartnershipProgramDialog,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            dialog_program: false,
            approval_status: null,
            confirm_approve: false,
            approval_title: null,
            data: [],
            loading_approve: false,
            document: null,
            list_program: null,
            disabled_process: false,
        };
    },

    watch: {
        // disabled_process: function(val) {
        //   if (!this.list_program.length || !this.document.length) {
        //     this.disabled_process = true
        //   }
        // }
    },

    mounted: function () {
        this.fetchData();
        this.getDocument();
        this.getProgram();
    },

    methods: {
        fetchData() {
            const context = this;
            const id = this.$route.query.id;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/detail/${id}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.isLoading = true;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data = response.data;
                }
                context.isLoading = false;
            });
        },

        detailFormPartnership() {
            this.$router.push({
                path: "/partnership-member-form",
                query: { id: this.$route.query.id },
            });
        },

        confirmApprove(partner_status) {
            this.confirm_approve = true;
            this.approval_status = partner_status;

            if (partner_status === "APPROVE") {
                this.approval_title =
                    "Apakah anda yakin untuk menyetujui permintaan partner?";
            } else {
                this.approval_title =
                    "Apakah anda yakin untuk menolak permintaan partner?";
            }
        },
        getDocument() {
            const context = this;
            const param = `partner_id=${this.$route.query.id}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/documentations?${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.document = response.data;
                }
            });
        },
        async sendProcessPartner() {
            const context = this;
            const id = this.$route.query.id;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/${id}/update-status?status=${context.approval_status}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const approval_status = context.approval_status;
            const data = {
                status: approval_status,
            };

            context.loading_approve = true;

            try {
                var response = await axios.put(url, data, options);
                if (response.status === 200) {
                    context.$store.commit("showAlert", {
                        message: `Berhasil memproses data partner`,
                        type: "success",
                    });
                }

                context.loading_approve = false;
                context.confirm_approve = false;
                context.fetchData();
            } catch (error) {
                context.$store.commit("showAlert", {
                    message: `Gagal memproses partnership program`,
                    type: "error",
                });
                context.loading_approve = false;
                context.confirm_approve = false;
            }
        },
        openDocument(doc) {
            const context = this;
            const param = `document_url=${doc.data_url}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/download/documentation?${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    var url = response.data.download_url;
                    window.open(url, "_blank");
                }
            });
        },
        getProgram() {
            const context = this;
            const param = `partner_id=${this.$route.query.id}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/programs?${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.list_program = response.data;
                }
            });
        },
        async selectedRowProgram(param) {
            const context = this;
            const id = this.$route.query.id;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/${id}/assign-program?program_id=${param.id}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const data = {
                program_id: param.id,
            };

            context.dialog_program = false;

            try {
                var response = await axios.put(url, data, options);
                if (response.status === 200) {
                    context.$store.commit("showAlert", {
                        message: `Partnership program berhasil ditambahkan`,
                        type: "success",
                    });
                }

                context.getProgram();
            } catch (error) {
                context.$store.commit("showAlert", {
                    message: `Gagal menambahkan partnership program`,
                    type: "error",
                });

                context.confirm_approve = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// PartnershipMemberDetail.vue?489e0de6